import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import PlainContainer from "../PlainContainer";
import "./LoginContainer.css";
import VerticalLine from "../VerticalLine";
import HorizontalLine from "../HorizontalLine";
import LoginCredentials from "./LoginCredentials";
import LoginQRCode from "./LoginQRCode";
import LoginPIN from "./LoginPIN";
import { onDLockLoginUserInLibrarian } from "../../redux/actions/onLoginUser";
class LoginViewQRContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isAuthenticating: false
    };
    this.unmounted = false;

    // References to clear polling functions from both components
    this.qrCodePollingRef = React.createRef();
    this.pinPollingRef = React.createRef();
    this.loginPinRef = React.createRef();
  }

  // Method to stop all polling activities
  stopAllPolling = () => {
    // Check if the components have provided their clearPolling functions
    if (this.qrCodePollingRef.current) {
      this.qrCodePollingRef.current();
    }

    if (this.pinPollingRef.current) {
      this.pinPollingRef.current();
    }
  };

  // Common handler for both QR code and PIN authentication
  handleAuthStatusChange = async (data) => {

    if (this.unmounted) return;

    // Only proceed if not already authenticating to prevent double-calls
    if (this.state.isAuthenticating) return;

    if (data.status === "APPROVED") {
      try {
        // Set authenticating flag to prevent duplicate processing
        if (!this.unmounted) {
          this.setState({ isAuthenticating: true });
        }

        // Stop all polling activities when authentication is successful
        this.stopAllPolling();

        // Call the login function to complete authentication
        const payload = {
          data,
          history: this.props.history,
        };
        await onDLockLoginUserInLibrarian(payload);
      } catch (error) {
        console.log("Authentication error:", error);
        // Display error in LoginPIN component
        if (!this.unmounted && this.loginPinRef.current) {
          this.loginPinRef.current.setError(error.message || "Błąd logowania");
          this.loginPinRef.current.resetPinState();
        }
      }
    } else if (data.status === "REJECTED") {
      if (!this.unmounted && this.loginPinRef.current) {
        this.loginPinRef.current.setError("Odrzucone");
        this.loginPinRef.current.resetPinState();
      }
    }    // Reset authenticating state to allow retry

    this.setState({ isAuthenticating: false });
  };

  componentWillUnmount() {

    this.unmounted = true;

    // Stop all polling to prevent state updates after unmount
    this.stopAllPolling();
  }

  render() {
    return (
      <div
      // style={{
      //   position: "fixed",
      //   top: "0",
      //   left: "0",
      //   width: "100vw",
      //   height: "100vh",
      //   zIndex: 100,
      //   backgroundImage:
      //     "linear-gradient(rgba(109,200,245,0.6) ,rgba(164,164,244,0.35))",
      // }}
      >
        <PlainContainer
          widthInVw={50}
          heightInVh={65}
          customStyles={{
            top: "50%",
            position: "absolute",
            left: "50%",
            transform: "translate(-50%, -50%)",
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            justifyContent: "space-evenly",
            alignItems: "center",
          }}
        >
          <>
            <div className="login-view-form-qr-container">
              <LoginCredentials />
              <VerticalLine />

              <div>
                <div><LoginQRCode
                  onAuthStatusChange={this.handleAuthStatusChange}
                  intent="LOGIN"
                  clearPollingRef={fn => this.qrCodePollingRef.current = fn}
                /></div>
                <HorizontalLine />
                <div><LoginPIN
                  ref={this.loginPinRef}
                  intent="LOGIN"
                  onAuthStatusChange={this.handleAuthStatusChange}
                  clearPollingRef={fn => this.qrCodePollingRef.current = fn}
                /></div>
              </div>
              {
                /*<div style={{
                  width: "20vw",
                  height: "20vw",
                  background: "#99a9f2",
                  lineHeight: "20vw",
                  color: "#fff",
                  margin: "0px 2.5em"
                }}
                ></div>
               */}
            </div>
            {/* <LoginGoogle /> */}
          </>
        </PlainContainer>
      </div >
    );
  }
}

export default withRouter(LoginViewQRContainer);
